const { REACT_APP_RESUME_URL } = process.env;

module.exports = [
    {
        href: '#intro',
        title: 'Hello',
    },
    {
        href: '#aboutme',
        title: 'About Me',
    },
    {
        href: '#portfolio',
        title: 'Portfolio',
    },
    {
        href: '#contact',
        title: 'Contact Me',
    },
    {   
        href: 'https://drive.google.com/file/d/1UJMKOMw6pujEWfSkcXYMs7H2rStXCM2w/view?usp=sharing',
        title: 'Resume',
    },
];